import { render, staticRenderFns } from "./menu-board.vue?vue&type=template&id=60ecb5b0&"
import script from "./menu-board.vue?vue&type=script&lang=js&"
export * from "./menu-board.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60ecb5b0')) {
      api.createRecord('60ecb5b0', component.options)
    } else {
      api.reload('60ecb5b0', component.options)
    }
    module.hot.accept("./menu-board.vue?vue&type=template&id=60ecb5b0&", function () {
      api.rerender('60ecb5b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/menu-board.vue"
export default component.exports